// extracted by mini-css-extract-plugin
export default {"page":"PageContainer_page__Cd8xf"};